import { API_ENDPOINTS, getApiUrl } from "../config";
import { FieldsForProductInfo } from "../view-models/FieldsForProductInfo";
import { ReferenceNumberInfo } from "../view-models/ReferenceNumberInfo";
import { buildBffRequestHeaders } from "./bffRequestHeaders";


export const postReferenceNumberSearch = async (data: any): Promise<ReferenceNumberInfo> => {
    const url = getApiUrl(API_ENDPOINTS.REFERENCE_NUMBER_SEARCH);
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: buildBffRequestHeaders(),
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`postReferenceNumberSearch failed: ${response.status} ${response.statusText} - ${text}`);
      }
      const text = await response.text();
      let wrapper: any;
      try {
        wrapper = JSON.parse(text);
      } catch {
        throw new Error('API returned invalid JSON for postReferenceNumberSearch');
      }
      if (wrapper && wrapper.success === false) {
        throw new Error(wrapper.error || wrapper.message || 'postReferenceNumberSearch failed');
      }
      let payload: any = wrapper;
      if (wrapper && typeof wrapper.data === 'string') {
        try {
          payload = JSON.parse(wrapper.data);
        } catch {
          payload = wrapper.data;
        }
      } else if (wrapper && typeof wrapper.data === 'object') {
        payload = wrapper.data;
      }
      return payload as ReferenceNumberInfo;
      }
    catch (error) {
      console.error('Fetch error:', error);
      if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
        throw new Error('CORS Error: Unable to connect to the API server. Make sure your backend server is running and configured to allow CORS requests from this origin.');
      }
      throw error;
    }
  }

  export const getFieldsForProductRequest = async (gffpData: any): Promise<FieldsForProductInfo> => {
    const url = getApiUrl(API_ENDPOINTS.GET_FIELDS_FOR_PRODUCT_FOR_RECEIVE);
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: buildBffRequestHeaders(),
        body: JSON.stringify(gffpData),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const text = await response.text();
      let wrapper: any;
      try {
        wrapper = JSON.parse(text);
      } catch (parseError) {
        console.error('Failed to parse JSON:', parseError);
        throw new Error('API returned invalid JSON');
      }

      if (wrapper && wrapper.success === false) {
        throw new Error(wrapper.error || 'Failed to load fields for product');
      }

      let payload: any = wrapper;
      if (wrapper && typeof wrapper.data === 'string') {
        try {
          payload = JSON.parse(wrapper.data);
        } catch (nestedParseError) {
          console.error('Failed to parse nested data JSON:', nestedParseError);
          throw new Error('API returned invalid nested JSON');
        }
      } else if (wrapper && typeof wrapper.data === 'object') {
        payload = wrapper.data;
      }

      // If backend embeds an error payload within a 200, surface it as an exception
      const embeddedError =
        payload?.ErrorDetail?.ErrorString ||
        payload?.ErrorDetail?.ErrorMessage ||
        payload?.message ||
        payload?.Message;
      if (embeddedError) {
        throw new Error(String(embeddedError));
      }

      // Normalize key casing from backend (often PascalCase) to our camelCase model
      const normalized: FieldsForProductInfo = {
        fqdoInfo: (payload as any).fqdoInfo ?? (payload as any).FqdoInfo,
        productFieldInfos: ((payload as any).productFieldInfos ?? (payload as any).ProductFieldInfos ?? []).map((f: any) => ({
          ...f,
          visibility: f.visibility ?? f.Visibility,
        })),
        dynamicFieldInfos: (payload as any).dynamicFieldInfos ?? (payload as any).DynamicFieldInfos,
      } as FieldsForProductInfo;

      return normalized;
    } catch (error) {
      console.error('Fetch error:', error);
      throw error;
    }
  }

  export const validateConsumer = async (data: any): Promise<any> => {
    const url = getApiUrl(API_ENDPOINTS.VALIDATE_CONSUMER_FOR_RECEIVE);
   
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: buildBffRequestHeaders(),
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`ValidateConsumer failed: ${response.status} ${response.statusText} - ${text}`);
      }
      const text = await response.text();
      let wrapper: any = {};
      try {
        wrapper = JSON.parse(text);
      } catch {
        return text;
      }
      let payload: any = wrapper;
      if (wrapper && typeof wrapper.data === 'string') {
        try {
          payload = JSON.parse(wrapper.data);
        } catch {
          payload = wrapper.data;
        }
      } else if (wrapper && typeof wrapper.data === 'object') {
        payload = wrapper.data;
      }
      return payload;
    } catch (error) {
      console.error('Fetch error:', error);
      if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
        throw new Error('CORS Error: Unable to connect to the API server. Make sure your backend server is running and configured to allow CORS requests from this origin.');
      }
      throw error;
    }
  }
